import { Box, Typography } from '@mui/material';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import OfferGridData from '../Models/OfferGridData';
import { formatNumber, formatNumberFloat } from '../Services/FormatService';

interface OfferSummaryProps {
  offer: OfferGridData;
  tonQuotaTypes: number[];
}

export default function OfferSummary({ offer, tonQuotaTypes }: OfferSummaryProps) {
  const formatQuotaValue = (name: string, quantity: number | null | undefined, quotaType: number) => {
    const amount = quantity == null ? '' : formatNumber(quantity.toString());
    const quantityWithUnit = amount ? `${amount} ${tonQuotaTypes.includes(quotaType) ? 'tonn' : 'kg'}` : '';

    return [name, quantityWithUnit].filter(Boolean).join(' · ');
  };

  const codValueRatio = offer.codValueRatio == null ? '' : formatNumber(offer.codValueRatio.toString());
  const details = [
    ['Óska eftir', formatQuotaValue(offer.offerQuotaName, offer.offerQuotaQuantity, offer.offerQuotaType)],
    ['Greiða með', formatQuotaValue(offer.paymentQuotaName, offer.paymentQuotaQuantity, offer.paymentQuotaType)],
    ['Þorskígildihlutfall', codValueRatio ? `${codValueRatio}%` : ''],
    ['Virðisstuðull', formatNumberFloat(offer.valueCoefficient?.toString() ?? '')],
  ].filter(([, value]) => value !== '');

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
        <Box sx={{ display: 'flex', p: 1.25, borderRadius: 2, bgcolor: 'primary.light', color: 'primary.main' }}>
          <DirectionsBoatOutlinedIcon />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ overflowWrap: 'anywhere' }}><Box component="strong">{offer.shipNumber}</Box> {offer.shipName}</Typography>
          <Typography variant="body2" color="text.secondary">Dagsetning: {offer.date}</Typography>
        </Box>
      </Box>
      <Box component="dl" sx={{ m: 0, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
        {details.map(([label, value]) => (
          <Box key={label} sx={{ minWidth: 0 }}>
            <Typography component="dt" variant="body2" color="text.secondary">{label}</Typography>
            <Typography component="dd" variant="body2" sx={{ m: 0, fontWeight: 600, fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere' }}>{value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
